import React from 'react';
import { Outlet } from 'react-router-dom';
import Assets from '../../constants/images';
import { AuthSvgBottom, AuthSvgTop } from '../../constants/svgs';

const AuthLayout = () => {
  return (
    <div className="flex h-screen p-5 xl:p-0">
      <div className="w-1/2 hidden xl:flex xl:items-center xl:justify-center bg-auth-bg overflow-hidden">
        <div className="relative">
          <span className="absolute -top-3 right-0">
            <AuthSvgTop />
          </span>
          <img
            className="wh-400 object-cover object-center relative -left-10"
            src={Assets.AuthImage}
            alt=""
          />

          <div className="text-center mt-5 relative">
            <h1 className="heading">
              The Most Trusted And Fast <br /> messaging Ever
            </h1>
            <p className="text-sm mt-4 text-grey font-medium">
              Leader for Cryptocurrency Tracking and Tax <br /> Reporting
            </p>
          </div>
          <span className="absolute -bottom-16 -left-20">
            <AuthSvgBottom />
          </span>
        </div>
      </div>

      <div className="w-full sm:w-full xl:w-1/2 flex flex-col justify-center items-center">
        <div className="w-full sm:w-4/6 md:w-3/6 grid grid-cols-12">
          <div className="col-span-12">
            <img className="mb-7 w-60" src={Assets.LogoImage} alt="" />
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
